import {Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Class for the ImageHeaderComponent
 * @class
 */
@Component({
  selector: 'advtech-image-header',
  templateUrl: './image-header.component.html',
})
export class ImageHeaderComponent {

  /**
   * Title of the image header
   * @type {string}
   */
  title: string = "Add Image";

  /**
   * Returns true if multiple images are being uploaded
   * @type {boolean}
   */
  @Input()
  multiple: boolean = false;

  /**
   * Call to the save all function when Save All button is clicked
   * @type {EventEmitter<object>}
   */
  @Output()
  onSaveAll: EventEmitter<object> = new EventEmitter();

  /**
   * Save all image cards
   * @returns {void}
   */
  saveAll(): void {
    this.onSaveAll.emit();
  }

}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/image-header/image-header.component.ts